import { HobsProduct } from '../api/Packages'

export const isProduct = (product: any): product is HobsProduct => {
  return Boolean(product)
}
